import { useMutation, useQueryClient } from "@tanstack/react-query";

import { PENDING_PAUSE_REQUESTS_QUERY_KEY } from "@/hooks/queries/useGetPendingPauseRequests";
import { guacHttpClient } from "@/lib/http";
import {
  DecideJobPauseRequestRequest,
  HttpResponse,
  JobPauseRequest,
} from "@/types";

// Approves or denies a staffer's pause/cover request. Approving applies the
// pause server-side, so every cache holding that job's status goes stale. 400s
// when the request was already decided, or when the job moved on since it was
// filed.
export function useDecideJobPauseRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: { approved: boolean; requestId: number }) => {
      const res = await guacHttpClient.post<
        JobPauseRequest,
        HttpResponse<JobPauseRequest>,
        DecideJobPauseRequestRequest
      >(`job-pause-requests/${variables.requestId.toString()}/decision`, {
        approved: variables.approved,
      });

      return res.data;
    },
    onSuccess: () => {
      // The request drops out of the poll once it leaves PENDING, which is what
      // clears its card from the corner stack.
      void queryClient.invalidateQueries({
        queryKey: PENDING_PAUSE_REQUESTS_QUERY_KEY,
      });
      // The notification payload carries no company id, so both job caches are
      // invalidated wholesale rather than by key.
      void queryClient.invalidateQueries({ queryKey: ["job"] });
      void queryClient.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
